import { formatDate } from '@autone/utils';
import { type DateRange } from 'react-day-picker';

export const getDisplayedDateRange = ({
  value,
  placeholder,
  lang,
}: {
  value?: DateRange;
  placeholder?: string;
  lang: string;
}) => {
  if (value?.from && value.to) {
    return `${formatDate(value.from, lang)} - ${formatDate(value.to, lang)}`;
  }
  return placeholder ?? null;
};
